import QRCode from "../../components/QRCode.vue";

export default {
    components: {QRCode},
    props: {
        index: Number,
        modelId: Object,
        modelObject: Object,
    },

    data: function () {
        return {
            loading: false,
            model: this.emptyModel(),
            modelErrors: null,
            modelMetadata: {
            },
        }
    },

    computed: {
        caption: function () {
            if (this.model.MFAEnabled === true)
                return 'Disable MFA';
            return 'Enable MFA';
        },
        actionLabel: function () {
            if (this.model.MFAEnabled === true)
                return 'Disable MFA';
            return 'Enable MFA';
        },
        qrCodeUrl: function () {
            if (this.model.MFAEnabled === false && this.model.TOTPAuthUrl != null)
                return this.model.TOTPAuthUrl;
            return null;
        }
    },

    methods: {
        fieldHasError: function (field) {
            return this.modelErrors != null && this.modelErrors.hasOwnProperty(field);
        },

        fieldErrorMessage: function (field) {
            if (this.modelErrors == null) {
                return '';
            }

            if (this.modelErrors.hasOwnProperty(field) === false) {
                return '';
            }
            
            return this.modelErrors[field];
        },

        emptyModel() {
            return {
                MFAEnabled: false,
                TOTPAuthUrl: null,
                ConfirmationCode: null
            }
        },

        async onLoadModelDataSource() {
            try {
                this.loading = true;

                if (((typeof this.modelId === 'number') && this.modelId > 0) ||
                    ((typeof this.modelId === 'string') && this.modelId !== '')) {
                    let url = this.$prepareServerUrl('/api/ui/currentuser/mfaSettings/', this.modelId, this.modelObject);
                    let response = await this.$http.get(url);
                    this.model = response.body;
                }
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },

        async onSaveModelDataSource() {
            try {
                this.loading = true;

                let url = this.$prepareServerUrl('/api/ui/currentuser/mfaSettings/', this.modelId, this.modelObject);
                let response = await this.$http.put(url, this.model, {  });

                this.$processServerJsonResponse(response.body, this.refreshScreen);

                this.model = response.body;
                return true;
            }
            catch (ex) {
                this.modelErrors = null;

                if (ex.body.errors) {
                    this.modelErrors = ex.body.errors;
                    return false;
                } else {
                    this.$processException(ex);    
                }

                return false;
            }
            finally {
                this.loading = false;
            }
        },

        onLoadFieldDataSources() {
            
        },

        show() {
            this.onLoadModelDataSource();
            this.onLoadFieldDataSources();
            this.$refs.dialog.show();
        },

        hide() {
            this.$refs.dialog.hide();
        },

        onDialogHide() {
            this.$emit('hide');
        },

        async onOkClick() {
            let validateResult = await this.$refs.modelForm.validate();
            if (validateResult) {
                let saveResult = await this.onSaveModelDataSource();
                if (saveResult) {
                    this.$emit('ok', { index: this.index, model: this.model, files: null });
                    this.hide();
                }
            }
        },

        onCancelClick() {
            this.hide();
        }
    }
}